module.exports = __webpack_public_path__ + "static/Test-6ad976329677dc7f13967ece9d1bf1c6.png";